<template>
  <div id="order-comfirm-sf">

    <!-- 标题 -->
    <div class="sf-panel-title">
      <s-checkbox class="check-logo" :value="sfChecked" @input="changeSFselect"></s-checkbox>
      <div class="title-value">顺丰上门取件</div>
      <div class="title-tips" v-if="!sfChecked">若需邮寄资料未备齐，可在订单支付后再选择顺丰上门；20点后顺丰下单可能会第二天上门取件，请知悉</div>
      <div class="long-title-tips" v-else>
        <div class="tips-value">请务必在下单前备齐全部邮寄资料；顺丰会在取件前通过短信发送快递员联系方式，若快递员未及时上门，请根据短信提供的信息联系快递员。</div>
        <el-tooltip v-if="sfChecked" placement="bottom" popper-class="order-sf-tooltip">
          <div slot="content" class="tips-content">
            请务必在下单前备齐全部邮寄资料；顺丰会在取件前通过短信发送快递员联系方式，若快递员未及时上门，请根据短信提供的信息联系快递员。
          </div>
          <img class="query-icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-query.png">
        </el-tooltip>

      </div>
      <div class="sf-price-box" v-if="sfChecked && pickUpAmountObj.original_price">
        <div class="sf-amout-info">
          <div class="amount-label">费用：</div>
          <div class="amount-number"><span>￥</span>{{pickUpAmountObj.pickup_amount / 100}}</div>
        </div>
        <div class="sf-original-price" v-if="pickUpAmountObj.pickup_amount === 0">￥{{pickUpAmountObj.original_price / 100}}</div>
        <div class="free-tips" v-if="pickUpAmountObj.pickup_amount === 0 && !hideFreeTips">
          本订单支持免费邮寄一次，费用由上上签承担
          <img @click="hideFreeTips = true" class="icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-close-white.png" alt="">
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="panel-body" v-if="sfChecked">
      <div class="sf-address-list">
        <div
          v-for="address in sfAddressExpand ? addresses : addresses.slice(0, 2)"
          :key="address.peer_address_id"
          class="sf-address-item"
          :class="{ active: address.peer_address_id == selectedSfAddress.peer_address_id }"
          @click="selectSFaddress(address)"
        >
          <div class="address-header">
            <div class="address-name">{{address.addressee}}</div>
            <div class="address-phone">{{address.mobile_phone}}</div>
          </div>
          <div class="address-content">
            <div class="address-detail">{{getAddress(pcds, address)}}</div>
            <div class="address-bottom">
              <div class="address-email">
                <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/address-email.png" alt="">
                <span class="email-value">{{address.email}}</span>
              </div>
              <img class="edit-icon" @click.stop="editAddress(address)" src="https://o.666visa.cn/static/ssqpeer/order/address-edit.png" alt="">
            </div>
          </div>
        </div>

        <div class="add-address-box" @click="addAddress()" >
          <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/address-add.png" alt="">
          <div class="add-address-label">新增收货地址</div>
        </div>
      </div>
      <div class="expand-box"  v-if="addresses.length > 2">
        <div class="expand-content" @click="sfAddressExpand =! sfAddressExpand">
          <div class="expand-text" v-if="sfAddressExpand">收起地址</div>
          <div class="expand-text" v-else>展开全部地址</div>
          <img class="down-icon" :class="{expand: sfAddressExpand }" src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png" alt="">
        </div>
      </div>
      <!-- <div class="sf-supplier-address">
        <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/sf-address-icon.png">
        <div class="supplier-content">
          <div class="sf-address-label">资料将被寄送至以下地址：</div>
          <div class="sf-address-info">
            <div class="address-name">{{order.supplier_address.addressee}}（{{ order.country + '，' + User.peer.visa_peer_id }}）</div>
            <div class="address-phone">{{order.supplier_address.mobile_phone}}</div>
            <div class="address-detail">{{getAddress(pcds, order.supplier_address)}}</div>
          </div>
        </div>
      </div> -->
    </div>


    <!-- 顺丰选择提示 -->
    <sf-express-ensure-modal
      v-model="sfDialog"
      @sfCheckChange="isAllMaterialReady"
    ></sf-express-ensure-modal>

    <!-- 地址对话框 -->
    <sf-add-or-edit-address-modal
      ref="addrModal"
      v-model="addrDialog"
      :pcds="pcds"
      :sf-address-default-remove="true"
      :addr-modal-title="addrModalTitle"
      @addrModalClose="addrDialog = false;"
      @addrFormSubmited="addrFormSubmited"
    ></sf-add-or-edit-address-modal>
  </div>
</template>

<script>
import User from '@/libs/user';
import sfExpressEnsureModal from '../modals/sf-express-ensure-modal';
import sfAddOrEditAddressModal from '../modals/sf-add-or-edit-address-modal';
import sCheckbox from '../../../components/form/s-checkbox';


import pcdService from '../../../services/pcd-service';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import addressUtils from '../../../libs/address-utils';

export default {
  name: 'order-comfirm-sf',
  components: {
    sfAddOrEditAddressModal,
    sfExpressEnsureModal,
    sCheckbox,
  },
  props: {
    orderId: {
      type: Number,
      required: true,
      default: 0,
    },
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    pickUpAmountObj: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    sfChecked: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedSfAddress: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    addresses: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
  data() {
    return {
      pcds: {},
      addrToEdit: {}, // 编辑中的地址
      addrModalTitle: '',
      isGettingAddress: false, // 选择顺丰请求中
      addrDialog: false,
      sfDialog: false,
      sfAddressExpand: false, // 是否展开
      User,
      hideFreeTips: false,
    };
  },
  methods: {

    getAddress: addressUtils.getAddress,

    // 改变顺丰选择
    changeSFselect(SFselection) {
      if (SFselection) {
        MtaH5.clickStat('payvisaorder0shunfeng');
        this.$emit('sfSelectChange', SFselection);
        this.sfDialog = true;
      } else {
        this.$emit('sfSelectChange', SFselection);
      }
    },

    // 顺丰选中
    isShunfengChecked() {
      if (this.sfChecked === true) {
        MtaH5.clickStat('payvisaorder0shunfeng');
        this.sfDialog = true;
      }
    },

    // 所有资料准备完成
    isAllMaterialReady(sfChecked) {
      MtaH5.clickStat('payvisaorder0shunfengready');
      this.$emit('sfSelectChange', sfChecked);
      this.$emit('isAllMaterialReady');
      this.hideFreeTips = false;
    },

    // 打开新增或者编辑地址
    addAddress() {

      // 若是顺丰上门取件进入地址添加栏，去除设为默认地址选项
      this.addrDialog = true;
      this.addrModalTitle = '添加地址';

      // 重置
      this.$refs.addrModal.resetData();
    },

    // 编辑地址
    editAddress(address) {
      this.addrDialog = true;
      this.addrModalTitle = '编辑地址';
      this.addrToEdit = address;

      // 在外面设置内部数据
      this.$refs.addrModal.setDataOutter(address);
    },

    // 设置默认地址
    setDefaultAddress(address) {
      Http.post('/peer_address_set_default', {
        peer_address_id: address.peer_address_id,
      }).then(() => {
        this.addresses.forEach((ad) => { ad.is_default = 0; });
        address.is_default = 1;
        utils.msg.success('设置成功');
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 外面还需要处理
    addrFormSubmited(data) {
      const { action, postData, address } = data;
      const { peer_address_id } = this.selectedSfAddress;
      if (action === 'add') {
        postData.peer_address_id = address.peer_address_id;
        this.addresses.splice(0, 0, postData);

        if (postData.is_default) {
          this.setDefaultAddress(postData);
        }
      } else {

        utils.extend(this.addrToEdit, postData);

        // 如果是编辑当前选择的地址，需要刷新供应商地址
        if (peer_address_id && peer_address_id === postData.peer_address_id) {
          this.$emit('editedSfAddress', postData);
        }

        if (postData.is_default) {
          this.setDefaultAddress(this.addrToEdit);
        }
      }

      this.addrToEdit = null;
    },

    // 顺丰上门地址选择处理
    selectSFaddress(address) {

      // 若上次请求没返回，不继续发请求
      if (this.isGettingAddress) return;
      const url = '/pickup_submit';
      const postData = {
        user_order_id: this.orderId,
        address: {
          addressee: address.addressee,
          mobile_phone: address.mobile_phone,
          province_code: address.province_code,
          city_code: address.city_code,
          county_code: address.county_code,
          detail_address: address.detail_address,
        },
      };

      utils.msgbox.confirm('是否确定使用该寄件地址？', '提示', {
        confirmButtonText: '　是　',
        cancelButtonText: ' 再想想 ',
        type: 'info',
      }).then(() => {
        this.isGettingAddress = true;
        Http.post(url, postData).then((data) => {
          this.isGettingAddress = false;
          this.$emit('SFaddressSelected', {
            data,
            address,
          });
        }).catch((e) => {
          if (e) console.log(e);
          this.isGettingAddress = false;
        });
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less">
@import  '../../../assets/less/variable';
#order-comfirm-sf {
  background-color: white;
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  padding: 0;
  line-height: 1;
  .sf-panel-title {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .check-logo{
      flex-shrink: 0;
      margin-right: 12px;
    }
    .title-value{
      flex-shrink: 0;
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
    }
    .title-tips{
      flex-grow: 1;
      margin-left: 12px;
      color: #91999F;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
    }
    .long-title-tips{
      flex-grow: 1;
      margin-left: 12px;
      display: flex;
      align-items: center;
      .tips-value{
        max-width: 518px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #91999F;
        font-size: 14px;
      }
      .query-icon{
        width: 18px;
        height: 18px;
        margin-left: 4px;
      }
    }
    .sf-price-box{
      flex-shrink: 0;
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;
      position: relative;
      padding-right: 24px;
      .sf-amout-info{
        display: flex;
        align-items: center;
        .amount-label{
          color: #5F666E;
          font-size: 12px;
          margin-top: 2px;
        }
        .amount-number{
          color: #FF8033;
          font-size: 20px;
          font-weight: 600;
          span{
            font-size: 14px;
          }
        }
      }
      .sf-original-price{
        margin-top: 2px;
        color: #DDDDDD;
        font-size: 12px;
        text-decoration: line-through;
      }
      .free-tips{
        position: absolute;
        right: 0;
        bottom: 100%;
        margin-bottom: 10px;
        background:rgba(47,51,61,0.94);
        color: #fff;
        font-size: 12px;
        padding: 0 12px;
        height: 42px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        &::after{
          content: "";
          border-width: 5px;
          border-style: solid;
          border-color: rgba(47,51,61,0.94) transparent transparent transparent;
          position: absolute;
          top: 100%;
          right: 26px;
        }
        .icon{
          cursor: pointer;
          width: 14px;
          height: 14px;
          margin-left: 12px;
        }
      }
    }
  }
  .panel-body {
    border-top: 1px solid #E9EEF2;
    padding:20px 24px 24px 24px;
    .sf-address-list{
      display: flex;
      flex-wrap: wrap;
      margin-right: -18px;
      margin-bottom: -18px;
      .add-address-box{
        height: 118px;
        width: 114px;
        background: #FAFBFC;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius:2px;
        margin-right: 18px;
        margin-bottom: 18px;
        cursor: pointer;
        .icon{
          width: 15px;
          height: 19px;
          margin-bottom: 6px;
        }
        .add-address-label{
          font-size: 12px;
          color: #599FFF;
        }
      }
      .sf-address-item{
        border-radius:2px;
        border:2px solid #E9EEF2;
        position: relative;
        z-index: 1;
        width: 300px;
        height: 118px;
        overflow: hidden;
        border-radius:2px;
        background: #fff;
        margin-right: 18px;
        margin-bottom: 18px;
        cursor: pointer;
        &::before{
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 4px;
          background: url(https://o.666visa.cn/static/ssqpeer/order/address-bar.png) no-repeat left top / cover;
        }
        &.active{
          border:2px solid rgba(89,159,255,0.87);
          &::after{
            content: "";
            position: absolute;
            right: -1px;
            top: -1px;
            z-index: 3;
            width: 28px;
            height: 28px;
            background: url(https://o.666visa.cn/static/ssqpeer/order/address-active.png) no-repeat center / 100% 100%;
          }
        }
        &:hover{
          .edit-icon{
            opacity: 1 !important;
          }
        }
        .address-header{
          height: 42px;
          background: #FAFBFC;
          display: flex;
          align-items: center;
          padding: 0 10px;
          .address-name{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 16px;
            color: #2F333D;
            font-weight: 600;
          }
          .address-phone{
            flex-shrink: 0;
            color: #91999F;
            font-size: 12px;
            margin-left: 8px;
          }
        }
        .address-content{
          padding: 8px 10px;
          .address-detail{
            color: #5F666E;
            font-size: 12px;
            line-height: 18px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 6px;
          }
          .address-bottom{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .address-email{
              overflow: hidden;
              display: flex;
              align-items: center;
              .icon{
                width: 12px;
                height: 12px;
                margin-right: 4px;
                flex-shrink: 0;
              }
              .email-value{
                color: #5F666E;
                font-size: 12px;
                line-height: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .edit-icon{
              opacity: 0;
              flex-shrink: 0;
              margin-left: 8px;
              width: 14px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .expand-box{
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #599FFF;
      font-size: 14px;
      position: relative;
      &::after{
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 1px;
        background: #E9EEF2;
      }
      .expand-content{
        position: relative;
        z-index: 2;
        padding: 0 16px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .down-icon{
          width: 14px;
          height: 14px;
          margin-left: 8px;
          transition: 0.15s all;
          &.expand{
            transform: rotate(180deg);
          }
        }
      }

    }
    .sf-supplier-address{
      margin-top: 20px;
      background: #FAFBFC;
      padding: 16px 24px;
      display: flex;
      align-items: center;
      .icon{
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        margin-right: 18px;
      }
      .supplier-content{
        flex-grow: 1;
        overflow: hidden;
        .sf-address-label{
          color: #91999F;
          font-size: 14px;
          margin-bottom: 8px;
        }
        .sf-address-info{
          display: flex;
          align-items: center;
          .address-name{
            flex-shrink: 0;
            color: #2F333D;
            font-size: 14px;
            margin-right: 12px;
          }
          .address-phone{
            flex-shrink: 0;
            color: #5F666E;
            font-size: 14px;
            margin-right: 12px;
          }
          .address-detail{
            color: #5F666E;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

      }
    }

  }

}
</style>
<style lang="less">
.order-sf-tooltip{
  padding: 0;
  background: rgba(47,51,61,0.94) !important;
  border-radius: 2px;
  .popper__arrow{
    border-bottom-color: rgba(47,51,61,0.94) !important;
    &::after{
      border-bottom-color: rgba(47,51,61,0.94) !important;
    }
  }
  .tips-content{
    max-width: 320px;
    padding: 12px 12px;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-comfirm-sf.vue